jQuery(function(){

    var paths = window.location.pathname.split('/');
    var path = paths[3];

    if(window.location.pathname === '/auto/repair/' + path + '/appointment') {
        sessionStorage.clear();
    }

    var $date = jQuery('input[name="date"]');

    jQuery('body').on('click', '.vehicle-inspection__search-link', function(e){
        e.preventDefault();
        $date.parent().removeClass('input__calendar-container--error');

        var get = { };
        var city = jQuery('select[name="city"]').find(':selected').val();

        jQuery('.vehicle-inspection__times').hide();

        if($date.val()) {
            if(city)
                get.city = city;

            get.radio = true;

            jQuery.get('/api/facilities', get, function(response){
                var $table = jQuery('#facilities tbody');
                $table.empty();
                $table.append(response);

                jQuery('.vehicle-inspection__facilities').show();
            });

            sessionStorage.setItem('city', city);
            sessionStorage.setItem('date', $date.val());

        } else {

            $date.parent().addClass('input__calendar-container--error');
            $date.parent().find('.input__text-error-message-copy').text("Preferred date required");

        }
        return false;
    });

    jQuery('form').on('change', 'input[name="facility_name"]', function() {
        var $radio = jQuery(this);
        var facility = $radio.val();
        var get = { };

        get.facility = facility;
        jQuery.get('/api/available_times', get, function(response) {
            var $times = jQuery('.vehicle-inspection__times');

            jQuery('.vehicle-inspection__times').children('.input__radio').remove();
            jQuery('#facility-header').html(facility);
            $times.append(response);
            jQuery('.vehicle-inspection__times').show();
        });

        jQuery.each($radio.closest('.table__column-radio-cell').siblings('td'), function(index, object){
            var $td = jQuery(object);

            switch($td.data('label')) {
                case 'Address':
                    sessionStorage.setItem('facility_address', jQuery.trim($td.text()));
                    break;
                case 'Phone':
                    sessionStorage.setItem('facility_phone', jQuery.trim($td.text()));
                    break;
            }
        });

        sessionStorage.setItem('facility', facility);
    });

    jQuery('form').on('change', 'input[name="available_time"]', function() {
        var $radio = jQuery(this);

        sessionStorage.setItem('inspection_time', $radio.val());

        jQuery('.form-cta--hidden').removeClass('form-cta--hidden');
    });

    var $select_year = jQuery('select[name="year"]');
    var $select_make = jQuery('select[name="make"]');
    var $select_model = jQuery('select[name="model"]');


    jQuery('body').on('change', 'select[name="make"]', function(){
        var get = { };
        get.make = $select_make.val();

        jQuery.get('/api/car_models', get, function(response){
            $select_model.empty().append(response);
            $select_model.removeAttr('disabled');
        });

    });


    jQuery('body').on('change', 'select[name="year"]', function(){
        jQuery('.form-cta--hidden').removeClass('form-cta--hidden');
    });

    jQuery('body').on('submit', '#vehicle-appointment-form', function(e){
		e.preventDefault();

		window.location = '/auto/repair/' + path + '/vehicle';
		return false;
	});


    jQuery('body').on('submit', '#vehicle-information-form', function(e){
		e.preventDefault();

        sessionStorage.setItem('car_make', $select_make.val());
        sessionStorage.setItem('car_model', $select_model.val());
        sessionStorage.setItem('car_year', $select_year.val());
        sessionStorage.setItem('car_notes', jQuery('textarea[name="comments"]').val());
        window.location = '/auto/repair/' + path + '/contact';
		return false;
	});


	jQuery('body').on('submit', '#vehicle-contact-form', function(e){
		var $form = jQuery(this);

		e.preventDefault();
        var $first_name = jQuery('input[name="first_name"]');
        var $last_name = jQuery('input[name="last_name"]');
        var $email = jQuery('input[name="email"]');
        var $home_phone = jQuery('input[name="home_phone"]');
        var $work_phone = jQuery('input[name="work_phone"]');
        var $work_ext = jQuery('input[name="work_ext"]');
        var $caa_membership = jQuery('input[name="caa_membership"]');

        sessionStorage.setItem('first_name', $first_name.val());
        sessionStorage.setItem('last_name', $last_name.val());
        sessionStorage.setItem('email', $email.val());
        sessionStorage.setItem('home_phone', $home_phone.val());
        sessionStorage.setItem('work_phone', $work_phone.val());
        sessionStorage.setItem('work_ext', $work_ext.val());
        sessionStorage.setItem('caa_membership', $caa_membership.val());

        window.location = '/auto/repair/' + path + '/summary';

		return false;
	});
    // Check if we are on summary page
    if (window.location.pathname === '/auto/repair/' + path + '/summary' || window.location.pathname === '/auto/repair/' + path + '/complete') {
        var date = moment(new Date(sessionStorage.getItem('date'))).format( 'dddd, MMMM, YYYY');
        jQuery('#inspection-date').html(date);
        jQuery('#inspection-time').html(sessionStorage.getItem('inspection_time'));

        jQuery('#inspection-location').html(sessionStorage.getItem('facility') + '<br>' + sessionStorage.getItem('facility_address'));
        jQuery('#inspection-facility-phone').html(sessionStorage.getItem('facility_phone'));

        jQuery('#vehicle').html(sessionStorage.getItem('car_year') + ' ' + sessionStorage.getItem('car_make') + ' ' + sessionStorage.getItem('car_model'));
        jQuery('#comments').html(sessionStorage.getItem('car_notes'));

        jQuery('#name').html(sessionStorage.getItem('first_name') + ' ' + sessionStorage.getItem('last_name'));
        jQuery('#home-phone').html(sessionStorage.getItem('home_phone'));
        jQuery('#work-phone').html(sessionStorage.getItem('work_phone'));
        jQuery('#email').html(sessionStorage.getItem('email'));
    }


    jQuery('body').on('submit', '#vehicle-summary-form', function(e){
        e.preventDefault();
        window.location.pathname = '/auto/repair/' + path + '/complete';

        return false;
    });


    jQuery('body').on('click', '#print-page', function(e){
        window.print();
    });

});
